import React from 'react';
import Header from './Common/header';

export default class Content_RankingList extends React.Component {
  render() {
    const { data = {}, eid } = this.props;
    const { moreLocal, iconMore } = data;

    return (
      <div className="item" id={`item_${eid}`}>
        <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@fom2wt`} data={data} eid={eid} />
        <div className="content" id={`content_${eid}`}>
          <div className="content_view" id={`content_view_id_${eid}`} style={{ textAlign: 'center' }}>
            <img src="/spa/portal/images/rankinglist/s01.jpg" />
          </div>
          <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
            {moreLocal == 'footer' ? <a href="javascript:;"><img src={iconMore} alt="" /></a> : ''}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_RankingList.js